

































import { Vue, Prop, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop({ type: Number, default: 0 }) originTwoType!: number;
  @Prop({ type: Number, default: 0 }) originCalculateType!: number;
  currentSample = {
    top: "-",
    rule1: "-",
    rule2: "-",
    rule3: "-",
  };
  setSampleData() {
    if (this.originTwoType === 1 && this.originCalculateType === 1) {
      this.currentSample = {
        top: "教师A，7月份完成点名签到12课次，则教师绩效工资统计为",
        rule1: "综合统计",
        rule2: "按点名课次计算，20元/课时",
        rule3: "合计总课时: 12课时<br/>绩效工资: 12 * 20 = 240元",
      };
    }
    if (this.originTwoType === 1 && this.originCalculateType === 2) {
      this.currentSample = {
        top: "教师A，7月份完成点名签到12课次，则教师绩效工资统计为",
        rule1: "综合统计，梯度计算 (超额累计)",
        rule2:
          "按点名课次计算<br/>0 < 按点名课次 ≤ 10，20元/课时<br/>10 < 按点名课次，50元/课时",
        rule3:
          "合计总课时: 12课时<br/>绩效工资: 10 * 20 + ( 12-10 ) * 50 = 300元",
      };
    }
    if (this.originTwoType === 1 && this.originCalculateType === 3) {
      this.currentSample = {
        top: "教师A，7月份完成点名签到12课次，则教师绩效工资统计为",
        rule1: "综合统计，梯度计算 (全额累计)",
        rule2:
          "按点名课次计算<br/>0 < 按点名课次 ≤ 10，20元/课时<br/>10 < 按点名课次，50元/课时",
        rule3: "合计总课时: 12课时<br/>绩效工资: 12 * 50 = 600元",
      };
    }
    if (this.originTwoType === 2 && this.originCalculateType === 1) {
      this.currentSample = {
        top: "教师A，7月份完成点名签到2课次，到课人次分别为2人和4人，则教师绩效工资统计为",
        rule1: "按课次单独统计",
        rule2: "底薪200元 + 按每节课到课人次计算，20元/人",
        rule3:
          "第1个点名课次绩效工资: 200 + 2 * 20 = 240元<br/>第2个点名课次绩效工资: 200 + 4 * 20 = 280元<br/>绩效工资: 240 + 280 = 520元",
      };
    }
    if (this.originTwoType === 2 && this.originCalculateType === 2) {
      this.currentSample = {
        top: "教师A，7月份完成点名签到2课次，到课人次分别为2人和4人，则教师绩效工资统计为",
        rule1: "按课次单独统计，梯度计算 (超额累计)",
        rule2:
          "底薪200元 + 按每节课到课人次计算<br/>0 < 按到课人次 ≤ 2，20元/人<br/>2 < 按到课人次，50元/人",
        rule3:
          "第1个点名课次绩效工资: 200 + 2 * 20 = 240元<br/>第2个点名课次绩效工资: 200 + 2 * 20 + ( 4-2 ) * 50 = 340元<br/>绩效工资: 240 + 340 = 580元",
      };
    }
    if (this.originTwoType === 2 && this.originCalculateType === 3) {
      this.currentSample = {
        top: "教师A，7月份完成点名签到2课次，到课人次分别为2人和4人，则教师绩效工资统计为",
        rule1: "按课次单独统计，梯度计算 (全额累计)",
        rule2:
          "底薪200元 + 按每节课到课人次计算<br/>0 < 按到课人次 ≤ 2，20元/人<br/>2 < 按到课人次，50元/人",
        rule3:
          "第1个点名课次绩效工资: 200 + 2 * 20 = 240元<br/>第2个点名课次绩效工资: 200 + 4 * 50 = 400元<br/>绩效工资: 240 + 400 = 640元",
      };
    }
  }
}
